import { QuestionParamsCardSortingType } from '@webapp/common/resources/question';

import { excludeHiddenAnswers } from '@webapp/survey/src/machine/helpers/logic';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class CardSortingApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { id, responseActor } = actor.getSnapshot().context;
        const { comment, value, extra } = responseActor.getSnapshot().context;

        const categoryNamesById = (extra as unknown as Array<{ id: string; name: string }>)?.reduce(
            (acc: Record<string, string>, { id, name }) => {
                acc[id] = name;

                return acc;
            },
            {},
        );

        const data = Object.entries(value).reduce((acc, [answer, categoryId]) => {
            if (typeof categoryId === 'string') {
                acc.push({ answer, categoryName: categoryNamesById[categoryId] });
            } else {
                acc.push({ answer, categoryId });
            }

            return acc;
        }, []);

        return {
            question: id,
            data,
            comment,
        };
    }

    public validate({ params: { required, cardSortingType }, responseActor, answersActors }: QuestionContext): boolean {
        const { value, extra } = responseActor.getSnapshot().context;

        if (!required) return true;

        if (cardSortingType === QuestionParamsCardSortingType.OPEN && extra) {
            if (!(extra as unknown as Array<{ id: string; name: string }>)?.every(({ name }) => Boolean(name))) {
                return false;
            }
        }

        return excludeHiddenAnswers(answersActors).every((answer) =>
            ['number', 'string'].includes(typeof value?.[answer.getSnapshot().context.id]),
        );
    }
}
